import HeroSeat from './HeroSeat';
export default HeroSeat;